<template>
  <div class="login" v-loading="loading">
    <div class="header">
      <!-- <div class="logo"></div>
      <div class="split"></div> -->
      <div class="title">
        <img src="@/web/assets/images/麦芒世纪3.png" alt="麦芒世纪" class="logo-icon">
        麦芒金聚合平台管理系统
      </div>
      <div class="header-actions">
        <button class="qr-button" @click="showQRCode">
          <i class="iconfont icon-erweima"></i>
          扫码体验
        </button>
      </div>
    </div>
    
    <!-- 二维码弹窗 -->
    <div v-if="showQR" class="qr-modal" @click="hideQRCode">
      <div class="qr-content" @click.stop>
        <div class="qr-header">
          <h3>微信小程序</h3>
          <button class="close-btn" @click="hideQRCode">×</button>
        </div>
        <div class="qr-body">
          <div class="qr-code">
            <!-- 小程序二维码图片 -->
            <img src="@/web/assets/images/miniprogram-qr.png" alt="小程序二维码" class="qr-image">
          </div>
          <p class="qr-tip">使用微信扫一扫，体验小程序</p>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 左侧营销内容 -->
      <div class="left-section">
        <div class="marketing-content">
          <div class="badge">找到最适合您的贷款方案</div>
          <h1 class="main-title">多家银行渠道，低至3.25%年利率</h1>
          <div class="subtitle">最快1天放款</div>
          <p class="description">
            贷款产品 - 我们提供多种贷款产品，满足您不同的资金需求，无论是购车、装修、教育还是创业，都能找到合适的方案
          </p>
          <div class="action-buttons">
            <button class="primary-button" @click="applyNow">立即申请</button>
            <button class="secondary-button" @click="learnMore">了解详情</button>
          </div>
        </div>
      </div>
      
      <!-- 右侧登录表单 -->
      <div class="right-section">
        <div class="form" @keypress.enter="login">
          <div class="title">麦芒金聚合平台管理系统</div>
          <el-form ref="ruleForm"  :hide-required-asterisk="true" :model="ruleForm" :rules="rules" class="login-form" >
            <el-form-item class="item" prop="phone">
              <template slot="label">
                <i class="iconfont icon-dengluzhanghao"/>
                <label class="label">登录帐号-欢迎入注</label>
              </template>
              <el-input size="nomarl" v-model="ruleForm.phone" placeholder="请输入登录账号"></el-input>
            </el-form-item>
            <el-form-item class="item" prop="password">
              <template slot="label">
                <i class="iconfont icon-denglumima"/>
                <label class="label">登录密码</label>
              </template>
              <el-input size="nomarl" type="password" v-model="ruleForm.password" placeholder="请输入登录密码"></el-input>
            </el-form-item>
            <el-form-item class="item" prop="code">
              <template slot="label">
                <i class="iconfont icon-tuxingyanzhengma"/>
                <label class="label">图形验证码</label>
              </template>
              <div>
                <div class="code-content">
                  <el-input size="nomarl" v-model="ruleForm.code" placeholder="请输入图形验证码"></el-input>
                  <div ref="codeImgeEl" class="code" @click="refreshCode">
                    <img :src="codeUrl" v-if="codeUrl"/>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="item" style="margin-top:20px">
              <el-button @click="login" class="login-button">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <!-- 底部版权信息 -->
      <div class="footer">
        <div class="text-sm text-white">
          © 2024 深圳市麦芒世纪科技有限公司. 保留所有权利. | 
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer"
            class="text-white hover:text-gray-200 transition-colors"
          >
            粤ICP备2023153129号
          </a>
        </div>
        <div class="flex gap-6 text-sm text-white">
          <a href="/privacy" class="text-white hover:text-gray-200 transition-colors">隐私政策</a>
          <a href="/terms" class="text-white hover:text-gray-200 transition-colors">服务条款</a>
          <a href="/sitemap" class="text-white hover:text-gray-200 transition-colors">网站地图</a>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'loginComponent',
  data () {
    return {
      loading: false,
      codeUrl: null,
      showQR: false,
      ruleForm: {
        phone: '',
        password: '',
        code: ''
      },
      text: '',
      rules: {
        phone: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  async mounted () {
    this.refreshCode()
  },
  methods: {
    async refreshCode () {
      const res = await this.$axios.get('/user/verify/code', { responseType: 'blob' })
      this.codeUrl = URL.createObjectURL(res.data)
    },
    async login () {
      this.loading = true
      try {
        await this.$refs.ruleForm.validate()
        const res = await this.$axios.post('/user/login', null, { params: { password: this.ruleForm.password, username: this.ruleForm.phone, code: this.ruleForm.code } })
        
        // 保存基本信息
        window.localStorage.setItem('token', res.data.result.accessToken)
        window.localStorage.setItem('name', res.data.result.fullName)
        window.localStorage.setItem('phone', res.data.result.phone)
        window.localStorage.setItem('changedPassWord', res.data.result.changedPassWord)
        
        // 保存权限信息
        window.localStorage.setItem('permission', JSON.stringify(res.data.result.permissions || []))
        
        // 保存完整的用户信息
        const userInfo = {
          userId: res.data.result.userId,
          fullName: res.data.result.fullName,
          phone: res.data.result.phone,
          roleId: res.data.result.roleId,
          permissions: res.data.result.permissions || [],
          showPhone: res.data.result.showPhone,
          applyDataRange: res.data.result.applyDataRange,
          advisoryDataRange: res.data.result.advisoryDataRange,
          channelId: res.data.result.channelId,
          // 检查是否为管理员（根据角色ID或用户名判断）
          roleCode: res.data.result.roleCode || (res.data.result.fullName === 'admin' ? 'SUPER_ADMIN' : 'USER'),
          username: this.ruleForm.phone
        }
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
        
        // 保存后端返回的菜单列表
        const userMenus = res.data.result.userMenuListVOS || []
        window.localStorage.setItem('userMenus', JSON.stringify(userMenus))
        
        console.log('登录成功，保存的用户信息:', userInfo)
        console.log('保存的权限列表:', res.data.result.permissions)
        console.log('保存的菜单列表:', userMenus)
        
        this.$router.replace({ path: '/' })
      } finally {
        this.refreshCode()
        this.loading = false
      }
    },
    applyNow () {
      window.open("https://char.mmshiji.com/", "_blank")
    },
    learnMore () {
      window.open("https://char.mmshiji.com/", "_blank")
    },
    showQRCode () {
      this.showQR = true
    },
    hideQRCode () {
      this.showQR = false
    }
  }
}
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  background-color: #4660d2;
  display: flex;
  flex-direction: column;
  .header {
    height: 60px;
    background-color: #fff;
    padding: 6px 20px;
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .logo {
      // background-image: url(@/web/assets/images/logo.png);
      background-size: 100%;
      height: 48px;
      width: 126px;
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      font-size: 20px;
      font-weight: 700;
      gap: 12px;
      background: linear-gradient(135deg, #4660d2 0%, #3350cb 50%, #2940b8 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-shadow: 0 2px 4px rgba(70, 96, 210, 0.2);
      letter-spacing: 0.5px;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 2px;
        background: linear-gradient(90deg, #4660d2, #3350cb);
        border-radius: 1px;
      }
      
      .logo-icon {
        width: 36px;
        height: 36px;
        object-fit: contain;
        filter: drop-shadow(0 2px 4px rgba(70, 96, 210, 0.3));
        transition: transform 0.3s ease;
        
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    
    .header-actions {
      display: flex;
      align-items: center;
      
      .qr-button {
        display: flex;
        align-items: center;
        gap: 6px;
        background: linear-gradient(135deg, #4660d2, #3350cb);
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(70, 96, 210, 0.3);
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(70, 96, 210, 0.4);
        }
        
        .iconfont {
          font-size: 16px;
        }
      }
    }
    
    .split {
      height: 36px;
      width: 1px;
      margin: 6px 20px;
      background-color: #ebebeb;
    }
  }
  
  // 二维码弹窗样式
  .qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
    
    .qr-content {
      background: white;
      border-radius: 16px;
      padding: 0;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
      max-width: 320px;
      width: 90%;
      overflow: hidden;
      
      .qr-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 24px 16px;
        border-bottom: 1px solid #f0f0f0;
        
        h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }
        
        .close-btn {
          background: none;
          border: none;
          font-size: 24px;
          color: #999;
          cursor: pointer;
          padding: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.2s ease;
          
          &:hover {
            background: #f5f5f5;
            color: #666;
          }
        }
      }
      
      .qr-body {
        padding: 24px;
        text-align: center;
        
        .qr-code {
          margin-bottom: 16px;
          
          .qr-placeholder {
            width: 200px;
            height: 200px;
            border: 2px dashed #e0e0e0;
            border-radius: 8px;
            background: #f9f9f9;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            
            .qr-icon {
              font-size: 48px;
              margin-bottom: 12px;
            }
            
            p {
              margin: 0 0 4px 0;
              font-size: 16px;
              font-weight: 500;
              color: #666;
            }
            
            small {
              font-size: 12px;
              color: #999;
            }
          }
          
          .qr-image {
            width: 200px;
            height: 200px;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            background: #f9f9f9;
          }
        }
        
        .qr-tip {
          margin: 0;
          color: #666;
          font-size: 14px;
          line-height: 1.4;
        }
      }
    }
  }
  .content {
    flex: 1 auto;
    display: flex;
    background-image: url(@/web/assets/images/login-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    flex-direction: row;
    position: relative;
    
    .left-section {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      
      .marketing-content {
        max-width: 600px;
        color: #333;
        
        .badge {
          display: inline-block;
          background: #4660d2;
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 14px;
          margin-bottom: 24px;
        }
        
        .main-title {
          font-size: 48px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 16px;
          color: #1a1a1a;
        }
        
        .subtitle {
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 24px;
          color: #f59e0b;
        }
        
        .description {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 32px;
          color: #666;
        }
        
        .action-buttons {
          display: flex;
          gap: 16px;
          
          .primary-button {
            background: #f59e0b;
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            
            &:hover {
              background: #d97706;
              transform: translateY(-2px);
            }
          }
          
          .secondary-button {
            background: transparent;
            color: #4660d2;
            border: 2px solid #4660d2;
            padding: 10px 24px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            
            &:hover {
              background: #4660d2;
              color: white;
            }
          }
        }
      }
    }
    
    .right-section {
      width: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      
      .form {
        width: 100%;
        max-width: 400px;
        background: #ffffff;
        border-radius: 12px;
        padding: 40px;
        box-sizing: border-box;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        
        .item {
          margin-bottom: 10px;
        }
        
        .login-button {
          width: 100%;
          height: 44px;
          background: #3350cb;
          border-radius: 4px;
          color: #fff;
          margin-top: 10px;
          border: none;
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s ease;
          
          &:hover {
            background: #2940b8;
          }
        }
        
        .title {
          font-size: 24px;
          font-weight: 600;
          text-align: center;
          color: rgba(42,42,44,0.98);
          line-height: 37px;
          margin-bottom: 20px;
        }
        
        .code-content {
          display: flex;
          flex-direction: row;
          height: 40px;
          width: 100%;
          
          .code {
            margin-left: 10px;
            flex-direction: column;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            width: 120px;
            height: 40px;
            
            img {
              width: 120px;
              height: 40px;
              border: 1px solid #E6E7EF;
              border-radius: 4px;
            }
            
            /deep/ svg {
              width: 120px;
              height: 40px;
              background-color: #E6E7EF;
            }
          }
        }
        
        .login-form {
          margin-top: 20px;
          font-size: 14px;
          font-weight: 400;
          
          .icon {
            vertical-align: middle;
          }
          
          .label {
            margin-left: 8px;
          }
          
          .iconfont {
            color: #c7c8d0;
          }
        }
      }
    }
    
    .footer {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      text-align: center;
    }
    
    // 响应式设计
    @media (max-width: 1024px) {
      flex-direction: column;
      
      .left-section {
        .marketing-content {
          .main-title {
            font-size: 36px;
          }
        }
      }
      
      .right-section {
        width: 100%;
      }
      
      .footer {
        position: relative;
        bottom: auto;
        left: auto;
        transform: none;
        margin-top: 20px;
      }
    }
  }
}
</style>
